module.exports = __webpack_public_path__ + "public/img/Membuat Database Aplikasi Untuk Database Administrator.7b033b83.png";